import theme from "./theme"

export default {
    normal: {
        fontFamily: theme.fonts.sans,
        fontSize: 3,
        fontWeight: 300,
        letterSpacing: '0.05em'
    },
    caption: {
        fontFamily: theme.fonts.mono,
        fontSize: 3,
        fontWeight: 300,
        letterSpacing: '0.05em',
        textTransform: 'uppercase'
    },
    captionSmall: {
        fontFamily: theme.fonts.sans,
        fontSize: 2,
        fontWeight: 300,
        letterSpacing: '0.05em'
    },

    head: {
        fontFamily: theme.fonts.head,
        fontSize: 4,
        fontWeight: 900,
        letterSpacing: 0,
        mb: '1em',
        textTransform: 'lowercase'
    },
    subhead: {
        fontFamily: theme.fonts.sans,
        fontSize: 3,
        fontWeight: 800,
        letterSpacing: 0,
        mb: '1em',
        textTransform: 'lowercase'
    },
    body: {
        fontFamily: theme.fonts.sans,
        fontSize: 3,
        fontWeight: 300,
        letterSpacing: '0.05em'
    }
}
